import axios from 'axios';
import apiConfig from '../shared/config/api.config';

export default function civitfunOcrUserDataRequest(
  hotelId,
  lang,
  idCheckinGuest,
  documentCode,
  guestExtraData,
  images
) {
  const {
    host,
    URIs: { civitfunOcrUserData },
  } = apiConfig;

  let uri =
    `${host}${civitfunOcrUserData}?lang=${lang}&idCheckinGuest=${idCheckinGuest}&documentCode=${documentCode}`.replace(
      ':hotelId',
      hotelId
    );

  if (guestExtraData && Object.keys(guestExtraData).length) {
    var extraQueryString = Object.keys(guestExtraData)
      .map(key => key + '=' + guestExtraData[key])
      .join('&');
    uri += `&${extraQueryString}`;
  }

  return axios.post(uri, { document_front: images.front, document_back: images.back }).then(res => {
    return res.data;
  });
}
